import type { FaireProductEntity } from "../../entity_types/product";

export const p_rbgm27uw3v: FaireProductEntity = {
  token: "p_rbgm27uw3v",
  type: "product",
  name: "Elegant Gemstone Faceted Bead Necklace - Assortment 16 pcs",
  brandToken: "b_b8csz3xa8h",
  brandName: "Gypsy Soul",
  imageUrl:
    "https://cdn.faire.com/fastly/ead176bd4b3c0d82d044f54b61bf4a0691ce2fac4b00e78062f64cb2a5ca7b35.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9aca58b97d10f532e2076060185c1395dd788fc78f171d9488523226b3973825.jpeg",
    "https://cdn.faire.com/fastly/b4bfbb02fc34240354b5791561e45bd30af079525f8d1d82a0f52f606fd656f3.jpeg",
    "https://cdn.faire.com/fastly/5b1ae94f7f5036215e8566c72e3cf4892856f89fd95b28db3e7995c2f050d7ff.jpeg",
    "https://cdn.faire.com/fastly/49cf424e3b9b3dc77ff013dea5ae01e73f85a4366fec238d6c39cedbeeb35fbd.jpeg",
    "https://cdn.faire.com/fastly/b2f996e224457589fed6a1735088d988a603b64101327b6a27ec170096565f29.jpeg",
    "https://cdn.faire.com/fastly/f110825f7368ea00029b05045cd22ef2698e4209cb7a1820b541fcc731dee505.jpeg",
    "https://cdn.faire.com/fastly/4af754f1e151b8f8e138ad8cef53d4104d03b1d5fd5725777ca5c11d3a6d9700.jpeg",
    "https://cdn.faire.com/fastly/fc1800de33fa7e3fb5708fe4c0431cd37900ccb8df6c898bb8b908ca3699ab7e.jpeg",
    "https://cdn.faire.com/fastly/9a413dfb072b1219fdff9d4a2dd6510cbf7c43e1e4ce83b06b645dedd960549b.jpeg",
    "https://cdn.faire.com/fastly/7b3320bad72304d0853ef55e99322ce5fb61cf42fd1f593c0f2138eff940ad27.jpeg",
    "https://cdn.faire.com/fastly/3733c5e76ede7140e4392a21eaecaf3e662d1cb965be1567e7f53609bb55d18a.jpeg",
  ],
  priceDollars: 8.3,
  description:
    "Unveil the magic of nature with this breathtaking gemstone beaded necklace. This exclusive collection of 10 exquisite necklaces is designed for those who appreciate the finer things in life. Each necklace is a masterpiece, showcasing the allure of natural gemstones, meticulously faceted to create a dazzling display of color and light.\n\nThis set features a vibrant array of genuine gemstones, from the deep purple of amethyst, to the fiery red of garnet. Every necklace tells its own story, capturing the essence of these stunning natural treasures.\n\nPackage content:\n1 case contains an assortment of 16 handmade bead necklaces.\n",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:43.809Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
